import { useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

export type SystemName =
  | 'mapa_natal'
  | 'previsao'
  | 'sinastria'
  | 'tarot'
  | 'numerologia'
  | 'quiromancia'
  | 'i_ching'
  | 'design_humano'
  | 'astrologia_vedica'
  | 'astrocartografia'
  | 'agenda_astrologica'
  | 'fases_lua'
  | 'retrogrados'
  | 'eclipse'
  | 'diario_sonhos'
  | 'atlas_astral';

export function useSystemUsageTracker(systemName: SystemName) {
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;

    supabase.auth.getUser().then(({ data: { user } }) => {
      if (!user) return;
      supabase.rpc('track_system_usage', {
        p_user_id:    user.id,
        p_system_name: systemName,
      }).then(({ error }) => {
        if (error) console.error('[system_usage] tracking failed:', error.message);
      });
    });
  }, [systemName]);
}
